import { getCurrentLang } from '@umu/ukit-lang';
import { isInApp } from '@umu/umu-ua';

export const LANG = getCurrentLang().toUpperCase() as
    | 'CN'
    | 'EN'
    | 'ES'
    | 'TH'
    | 'JP'
    | 'TW'
    | 'KO'
    | 'FR'
    | 'ID'
    | 'RU'
    | 'PT'
    | 'DE'
    | 'IT'
    | 'VI'
    | undefined;

// 作为 Webview 页面使用的时，禁用 App 的分享按钮，无刷新
export const DisableAppShareButton = () => {
    if (!/share=/.test(location.href) && isInApp()) {
        location.replace('#share=0');
    }
};
